import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { FeildMappingEntity } from "../entities/feild-mapping-entity";
import dayjs = require("dayjs");
@Injectable()
export class FeildMappingRepository extends Repository<FeildMappingEntity> {
    constructor(@InjectRepository(FeildMappingEntity) private feildMappingRepository: Repository<FeildMappingEntity>
    ) {
        super(feildMappingRepository.target, feildMappingRepository.manager, feildMappingRepository.queryRunner);
    }

    async getFeildMappingDataRepo(): Promise<any> {
        const queryBuilder = this.createQueryBuilder('feild')
            .select([
                'feild.customer_number AS customerNumber',
                'feild.customer_name AS customerName',
                'feild.customer_po_no AS customerPONo',
                'feild.supplierName AS supplier_name',
                'feild.currency AS currency',
                'feild.requested_date AS requestedDate',
                'feild.delivery_method AS deliveryMethod',
                'feild.payment_terms AS paymentTerms',
                'feild.ship_to AS shipTo',
                'feild.delivery_terms AS deliveryTerms',
                'feild.packaging_terms AS packagingTerms',
                'feild.supplier_reference AS supplierReference',

                'feild.SNo AS SNo',
                'feild.item_description AS itemDescription',
                'feild.description1 AS description1',
                'feild.description2 AS description2',
                'feild.quantity AS quantity',
                'feild.unit_measurement AS unitMeasurement',
                'feild.price AS price',
                'feild.price_unit AS priceUnit',
                'feild.lineAmount AS line_amount',
                'feild.item_number AS itemNumber',
            ])

        const rawResults = await queryBuilder.getRawMany();
        return rawResults

    }



}